import {
  Button,
  ConfigProvider,
  DatePicker,
  Empty,
  Input,
  Select,
  Space,
  Spin,
  Table,
} from "antd";
// import Search from 'antd/es/input/Search';
import { ReactComponent as Search } from "asset/address/search.svg";
import axios from "axios";
import Meetingpop from "components/log/meetingpop";
import style from "css/meetinglog.module.css";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ko_KR from "antd/lib/locale/ko_KR";
import en_US from "antd/es/locale/en_US";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";

function ReserveMeeting() {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const { RangePicker } = DatePicker;
  // const handleCancel = () => {
  //     setSearch({
  //         ...search,
  //         START_DATE: null,
  //         END_DATE: null,
  //     }); // or setRange([])
  // };
  const [search, setSearch] = useState({
    START_DATE: new Date(new Date().setDate(new Date().getDate() - 30))
      .toISOString()
      .replace("T", " ")
      .slice(0, 10), // 시작일자 (검색)
    END_DATE: new Date(new Date().getTime())
      .toISOString()
      .replace("T", " ")
      .slice(0, 10), // 종료일자 (검색)
    // SEARCH_TYPE: '회의제목',
    SEARCH_MEETING_TYPE: "전체 회의",
    SEARCH_TXT: "",
  });
  const [isSearch, setIsSearch] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setIsSearch(true);
  }, [search.SEARCH_MEETING_TYPE, search.START_DATE, search.END_DATE]);

  const getMeetinglogList = useCallback(() => {
    setLoading(true);
    const config = {
      params: {
        START_DATE: search.START_DATE,
        END_DATE: search.END_DATE,
        // SEARCH_TYPE: search.SEARCH_TYPE,
        SEARCH_MEETING_TYPE: search.SEARCH_MEETING_TYPE,
        SEARCH_TXT: search.SEARCH_TXT,
      },
    };
    axios
      .get("/meetinglog/reserve/data", config)
      .then((res) => {
        if (res.status === 200) {
          let list = [];
          for (let i = 0; i < res.data.length; i++) {
            list.push({
              key: i + 1,
              SCD_ID: res.data[i].SCHEDULE_ID, // 스케줄 ID
              SCD_DATE: res.data[i].START_TIME.substring(0, 10), // 예약일자
              SCD_TM:
                res.data[i].START_TIME.substring(11) + // 예약시간
                " ~ " +
                res.data[i].END_TIME.substring(11),
              SCD_TITLE: res.data[i].TITLE, // 회의제목
              SCD_CONTENTS: res.data[i].CONTENTS, // 회의내용
              SCD_ROOM: "", // 회의실명
              SCD_TYPE:
                res.data[i].SCHEDULE_TYPE === "OFFLINE"
                  ? t("MEETING.TYPE.GENERAL")
                  : t("MEETING.TYPE.VIDEO"), // 구분
              // SCD_PTCP:                                                                       // 참석자
              //     res.data[i].PARTICIPANTS.length === 0
              //         ? "-"
              //         : res.data[i].PARTICIPANTS.length === 1
              //             ? res.data[i].PARTICIPANTS[0]
              //             : res.data[i].PARTICIPANTS[0] + " 외 " +
              //             (res.data[i].PARTICIPANTS.length - 1) + "명",
              // SCD_ENDPOINTS:                                                                  // 회의실명
              //     res.data[i].ENDPOINTS.length === 0
              //         ? "-"
              //         : res.data[i].ENDPOINTS.length === 1
              //             ? res.data[i].ENDPOINTS[0]
              //             : res.data[i].ENDPOINTS[0] + " 외 " +
              //             (res.data[i].ENDPOINTS.length - 1) + "개",
              SCD_PTCP: ptcpToString(res.data[i].PARTICIPANTS), // 참석자
              SCD_ENDPOINTS: endpointsToString(res.data[i].ENDPOINTS), // 회의실명

              DATA: res.data[i],
              lang: i18n.language,
            });
          }
          setMeetingInfo(list);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [search]);

  const ptcpToString = (ptcpList) => {
    if (i18n.language === "en-US") {
      return ptcpList.length === 0
        ? "-"
        : ptcpList.length === 1
        ? ptcpList[0]
        : ptcpList[0] + " & " + (ptcpList.length - 1) + " others";
    } else {
      return ptcpList.length === 0
        ? "-"
        : ptcpList.length === 1
        ? ptcpList[0]
        : ptcpList[0] + " 외 " + (ptcpList.length - 1) + "명";
    }
  };

  const endpointsToString = (endpointList) => {
    if (i18n.language === "en-US") {
      return endpointList.length === 0
        ? "-"
        : endpointList.length === 1
        ? endpointList[0]
        : endpointList[0] + " & " + (endpointList.length - 1) + " more";
    } else {
      return endpointList.length === 0
        ? "-"
        : endpointList.length === 1
        ? endpointList[0]
        : endpointList[0] + " 외 " + (endpointList.length - 1) + "개";
    }
  };

  useEffect(() => {
    // console.log("translator")
    setIsSearch(true);
  }, [t]);

  useEffect(() => {
    if (isSearch) {
      getMeetinglogList();
      setIsSearch(false);
    }
  }, [getMeetinglogList, isSearch]);

  // 검색 필터
  const dateFormat = "YYYY-MM-DD";
  // const selectOptions = [
  //     { value: '회의제목', label: '회의제목' },
  //     { value: '회의실명', label: '회의실명' },
  // ];
  const selectMeetingOptions = [
    { value: "전체 회의", label: t("MEETING.TYPE.ALL") },
    { value: "일반회의실", label: t("MEETING.TYPE.GENERAL") },
    { value: "영상회의실", label: t("MEETING.TYPE.VIDEO") },
  ];

  const [meetingInfo, setMeetingInfo] = useState([]);
  const columns = [
    {
      title: t("LIST.RESERVE_DATE"),
      dataIndex: "SCD_DATE",
      key: "SCD_DATE",
      align: "center",
      width: "12.5%",
    },
    {
      title: t("LIST.RESERVE_TIME"),
      dataIndex: "SCD_TM",
      key: "SCD_TM",
      align: "center",
      width: "12.5%",
    },
    {
      title: t("LIST.MEETING_TITLE"),
      dataIndex: "SCD_TITLE",
      key: "SCD_TITLE",
      align: "center",
      width: "30%",
    },
    {
      title: t("LIST.MEETING_ROOM"),
      dataIndex: "SCD_ENDPOINTS",
      key: "SCD_ENDPOINTS",
      align: "center",
      width: "10%",
    },
    {
      title: t("LIST.TYPE"),
      dataIndex: "SCD_TYPE",
      key: "SCD_TYPE",
      align: "center",
      width: "10%",
      // render: (_, record) => (

      //     <a>{record.SCD_TM}</a>
      // )
    },
    {
      title: t("LIST.PARTICIPANT"),
      dataIndex: "SCD_PTCP",
      key: "SCD_PTCP",
      align: "center",
      width: "12.5%",
    },
    {
      dataIndex: "DATA",
      key: "DATA",
      align: "center",
      width: "12.5%",
      render: (data) => (
        <>
          <Space size="middle">
            <Button
              type="link"
              onClick={() => {
                setModalData(data);
                setIsModalOpen(true);
              }}
            >
              {t("BTN.DETAILS")}
            </Button>
          </Space>
        </>
      ),
    },
  ];
  const [modalData, setModalData] = useState({
    SCHEDULE_ID: "",
    SCHEDULE_TYPE: "",
    TITLE: "",
    CONTENTS: "",
    START_TIME: "",
    END_TIME: "",
    RECORD_YN: "",
    PARTICIPANTS: [],
    ENDPOINTS: [],
  });

  const [excelLoading, setExcelLoading] = useState(false);
  const downloadExcel = () => {
    setExcelLoading(true);
    const url = "/meetinglog/excel/rsvMeetingList";
    const data = meetingInfo;
    const linkAtt = t("FILE_NAME.EXCEL.RSV_MEETING_LIST");
    const config = {
      responseType: "blob",
    };

    axios
      .post(url, data, config)
      .then((res) => {
        if (res.status === 200) {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: res.headers["content-type"] })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", linkAtt);
          document.body.appendChild(link);
          link.click();
        }
      })
      .finally(() => setExcelLoading(false));
  };

  return (
    <div className={style.userlog_container}>
      <Meetingpop
        isOpen={isModalOpen}
        close={() => setIsModalOpen(false)}
        data={modalData}
      />
      <div className={style.userlog_wrapper}>
        <div className={style.userlog_header}>
          <div className={style.userlog_searcharea}>
            <ConfigProvider
              theme={{
                token: {
                  controlHeight: 40,
                  fontFamily: "SpoqaHanSansNeo",
                },
              }}
              locale={i18n.language === "ko-KR" ? ko_KR : en_US}
            >
              {/* <Space> */}
              <div className={style.userlog_searchInput}>
                <RangePicker
                  value={[
                    dayjs(search.START_DATE, dateFormat),
                    dayjs(search.END_DATE, dateFormat),
                  ]}
                  onChange={(dates, dateStrings) => {
                    setSearch({
                      ...search,
                      START_DATE: dateStrings[0],
                      END_DATE: dateStrings[1],
                    });
                    setIsSearch(true);
                  }}
                  clearIcon={null}
                />
                {/* <Select
                                    defaultValue={search.SEARCH_TYPE}
                                    style={{
                                        width: 200,
                                    }}
                                    onChange={value =>
                                        setSearch({
                                            ...search,
                                            SEARCH_TYPE: value
                                        })
                                    }
                                    options={selectOptions}
                                /> */}
                <Select
                  // defaultValue={search.SEARCH_MEETING_TYPE}
                  value={search.SEARCH_MEETING_TYPE}
                  style={{ width: 200 }}
                  onChange={(value) =>
                    setSearch({
                      ...search,
                      SEARCH_TXT: "",
                      SEARCH_MEETING_TYPE: value,
                    })
                  }
                  options={selectMeetingOptions}
                />
                <Input
                  // className={style.search_input}
                  className="inputbox-size"
                  value={search.SEARCH_TXT}
                  placeholder={t("PLACEHOLDER.SEARCH.MEETING_TITLE")}
                  onChange={(e) =>
                    setSearch({
                      ...search,
                      SEARCH_TXT: e.target.value,
                    })
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setIsSearch(true);
                    }
                  }}
                  suffix={
                    <SearchOutlined
                      className="search-btn"
                      onClick={() => setIsSearch(true)}
                    />
                  }
                />
              </div>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      colorPrimaryHover: "#1cb691",
                      colorPrimaryActive: "#1cb691",
                    },
                  },
                }}
              >
                <Button
                  onClick={downloadExcel}
                  icon={
                    excelLoading ? <Spin size="small" /> : <DownloadOutlined />
                  }
                  className={style.pop_excelbtn}
                  disabled={excelLoading ? true : false}
                >
                  {t("BTN.DOWNLOAD_EXCEL")}
                </Button>
              </ConfigProvider>
              {/* </Space> */}
            </ConfigProvider>
          </div>
        </div>

        <div className={style.userlog_body}>
          <div className="list">
            <Table
              columns={columns}
              dataSource={meetingInfo}
              loading={loading}
              locale={{
                emptyText: <Empty description={t("MESSAGE.NO_DATA")} />,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReserveMeeting;
